__turbopack_context__.v({
  "link": "LocationBadge-module-scss-module__AYaXwa__link",
  "mapPinInner": "LocationBadge-module-scss-module__AYaXwa__mapPinInner",
  "mapPinOuter": "LocationBadge-module-scss-module__AYaXwa__mapPinOuter",
  "ping": "LocationBadge-module-scss-module__AYaXwa__ping",
  "pulse": "LocationBadge-module-scss-module__AYaXwa__pulse",
});
